import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkContainer } from '../general-functions';
import FinishButton from './finish-button';
import InputField from './input-field';
import '../global';

class UpdateInfo extends Component {

	getPrimaryContactInfo() {

		if ( getCategory() === 'PC' ) {
			return (
				<div className={ 'primary-contact-info' }>
					<input className={ 'form-control pc-checkbox' } id={ 'primary_contact' } type='checkbox' checked={ 'checked' } disabled />
					<p className={ 'pc-content' }>You are the ISDA primary contact of your organization. If this is no longer the case, please
						<a href={ 'mailto:' + getDefaultEmail() + '?subject=No Longer Primary Contact' } className={ 'primary-contact-link' } data-party-id={ getPartyID() }> email us</a>
						<i class="glyphicon glyphicon-envelope"></i></p>
					<br />
				</div>
			);
		} else {
			return (<div></div>
			);
		}
	}

	render() {
		const sectionName = 'update-information';
		const active = checkContainer( sectionName, this.props.currentPage );

		let primaryInterestObj = getAreaInterestOptions();
		let areasInterestObj = getGRPOptions();
		let otcActivityOptionsObj = getOTCActivityOptions();
		let specialTechnologySolutions = {};
		let conferenceAgendaObj = getConferenceAgendaTopicOptions();
		Object.keys( primaryInterestObj ).filter( function( key, index ) {
			if ( key.includes( 'TI_' ) ) {
				specialTechnologySolutions[ key ] = primaryInterestObj[ key ];
				delete primaryInterestObj[ key ];
			}
		} );
		let product_areas = getProductAreasOptions();

		let business_function = getBusinessFunctionOptions();
		return (
			<div id={ sectionName } className={ `preferences-section ${active}` }>
				<legend className="ajaxForm">Additional Information</legend>
				<div className="form-group ajaxForm">
					{ this.getPrimaryContactInfo() }
					<InputField type="text" id="job_title" name="Job Title" maxlength="80" value={ getUserTitle() } />
					<InputField type="select" id={"business_function"} name={"Business Area"} maxlength="100" options={ business_function } selected_option={getBusinessFunction()}  />
					<InputField type="text" id="department" name="Department" maxlength="60" value={ getDepartment() } />
					<InputField type="text" id={ 'address_line_1' } name={ 'Address Line 1' } maxlength={ '300' } value={ getAddress1() } />
					<InputField type="text" id={ 'address_line_2' } name={ 'Address Line 2' } maxlength={ '300' } value={ getAddress2() } />
					<InputField type="text" id={ 'address_line_3' } name={ 'Address Line 3' } maxlength={ '300' } value={ getAddress3() } />
					<InputField type="text" id={ 'city' } name={ 'City' } maxlength={ '300' } value={ getCity() } />
					<InputField type="select" id={ 'country' } name={ 'Country' } maxlength={ '300' } options={ getCountries() } selected_option={ getCountryCode() } />
					<InputField type="select" id={ 'state' } name={ 'State / Province' } maxlength={ '300' } options={ this.props.allStates } selected_option={ getStateCode() } />
					<InputField type="text" id={ 'postal_code' } name={ 'Postal Code' } maxlength={ '300' } value={ getPostalCode() } />
					<InputField type="text" id={ 'phone_number' } name={ 'Phone Number' } maxlength={ '300' } value={ getPhoneNumber() } />
					<InputField type="checkbox" id="policy_interest" name="Areas of interest (please check all that apply):"
					            options={ areasInterestObj } preselected={ getGRPInterest() } />
					<InputField type="checkbox" id="otc_activity" name="Please select the description that best applies to your institution in terms of your OTC derivatives activity (select all that apply):"
					            options={ otcActivityOptionsObj } preselected={ getOTCActivity() } />
					<InputField type="checkbox" id="primary_interest" name="ISDA benefits and resources of most value to you (check all that apply):"
					            options={ primaryInterestObj } special_arr={ specialTechnologySolutions } preselected={ getAreaInterest() } />
					<InputField type="checkbox" id="product_areas" name="Product areas of interest to you (check all that apply):"
					            options={ product_areas } preselected={ getProductAreas() } />
					<InputField type="checkbox" id="conference_agenda_topic" name="What agenda topics would you like to see covered at future ISDA conferences (choose all that apply):"
					            options={ conferenceAgendaObj } show_hidden_text_box_on_select={'OTR'} preselected={getConferenceAgendaTopic()} />
					<FinishButton text="Finish" />
				</div>
			</div>

		);

	}

}

function mapStateToProps( { currentPage, allStates } ) {
	return {
		currentPage, allStates
	};
}

export default connect( mapStateToProps )( UpdateInfo );